import React from 'react'

import { optionListItemStyle } from '../../../components';
import { RadioInput } from '../../../components';
import { AuthorizeProfilePaymentForm } from './';

export default class AuthorizeProfilePaymentComponent extends React.Component {
  constructor(props) {
    super(props);

    const [year, month] = props.paymentMethod.expirationDate && props.paymentMethod.expirationDate.split('-');
    this.state = {
      isUpdating: false,
      focused: undefined,
      cardNumber: props.paymentMethod.maskedCardNumber,
      expDate: `${month}/${year.substr(2)}`,
      firstName: props.paymentMethod.billToFirstName,
      lastName: props.paymentMethod.billToLastName,
      address: props.paymentMethod.billToAddressLine,
      city: props.paymentMethod.billToAddressCity,
      state: props.paymentMethod.billToAddressState,
      zip: props.paymentMethod.billToAddressZip
    }

    this.updateHandler = this.updateHandler.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.focusHandler = this.focusHandler.bind(this);
    this.blurHandler = this.blurHandler.bind(this);
    this.selectHandler = this.selectHandler.bind(this);
    this.paymentUpdateHandler = this.paymentUpdateHandler.bind(this);
    this.paymentDeleteHandler = this.paymentDeleteHandler.bind(this);
  }

  updateHandler(ev) {
    ev.stopPropagation();
    this.setState(oldState => ({isUpdating: !oldState.isUpdating}));
    return ev;
  }

  changeHandler(field, ev) {
    this.setState(oldState => ({
      ...oldState,
      [field]: ev.target.value
    }));
    return ev;
  }

  focusHandler(field, ev) {
    this.setState({ focused: field });
    return ev;
  }

  blurHandler(ev) {
    this.setState({ focused: undefined });
    return ev;
  }

  selectHandler(ev) {
    const { onSelect, paymentMethod, disabled } = this.props;
    ev.preventDefault();
    if (!disabled) { 
      onSelect(paymentMethod.customerPaymentProfileId, ev); 
    }

    return ev;
  }

  paymentUpdateHandler(ev) {
    const { onUpdate, paymentMethod } = this.props,
          { cardNumber, expDate, firstName, lastName, address, city, state, zip } = this.state;

    if (onUpdate) {
      onUpdate({
        CustomerPaymentProfileId: paymentMethod.customerPaymentProfileId,
        CardNumber: cardNumber,
        ExpirationDate: expDate,
        BillToFirstName: firstName,
        BillToLastName: lastName,
        BillToAddressLine: address,
        BillToAddressCity: city,
        BillToAddressState: state,
        BillToAddressZip: zip,
        BillToAddressCountry: 'USA'
      });
    }

    this.updateHandler(ev);
  }

  paymentDeleteHandler(ev) {
    ev.stopPropagation();
    const { onDelete, paymentMethod } = this.props;
    onDelete(paymentMethod.customerPaymentProfileId, ev);
  }

  render() {
    const { paymentMethod, isSelected, disabled = false } = this.props,
          { isUpdating, cardNumber, expDate, firstName, lastName, address, city, state, zip } = this.state,
          lastFour = paymentMethod.maskedCardNumber.replaceAll('X', ''),
          label=` ${lastFour}, ${paymentMethod.cardType}, Exp: ${paymentMethod.expirationDate} `;
    return (
      <div style={optionListItemStyle}>
        <div style={{width: '50%'}} onClick={this.selectHandler}>
          <RadioInput selected={isSelected} style={{display: 'inline-block', lineHeight: '18px', verticalAlign: 'middle'}} onClick={this.selectHandler} disabled={disabled} />
          <button className='btn btn-link' style={{color: 'inherit', textDecoration: 'none', padding: 0}} disabled={disabled}>
              {label}
          </button>
          <button className='btn btn-default' style={{float:'right'}} onClick={this.paymentDeleteHandler}><i className="fa fa-trash"/></button>
          <button className={`btn btn-default${isUpdating ? ' active' : ''}`} style={{float:'right'}} onClick={this.updateHandler}><i className="fa fa-edit"/></button>
        </div>
          <AuthorizeProfilePaymentForm
            hidden={!isUpdating}
            focused={true}
            handleChange={this.changeHandler}
            handleFocus={this.focusHandler}
            handleBlur={this.blurHandler}
            handleSubmit={this.paymentUpdateHandler}
            paymentMethod={{ cardNumber, expDate, firstName, lastName, address, city, state, zip }}
            buttonText={'Update Card'}
            style={{marginBottom: '10px'}}
            countriesStatesMap={this.props.countriesStatesMap}
          />
      </div>);
  }
}